import styled from "styled-components";
import Tooltip from "../../../../../base/others/tooltip/index.js";
import { TooltipContent } from "../../../../../base/others/tooltip/styled.js";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import Counter from "../../../../inputs/counter/index.js";
import { CounterButtonMobileWrapper } from "../../../../inputs/counter/components/counter-button/views/mobile/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const CounterContent = styled.div.withConfig({
    displayName: "styled__CounterContent",
    componentId: "sc-67ef5f81-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	padding: 12px 0px;

	&:not(:last-child) {
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;
export const Title = styled.div.withConfig({
    displayName: "styled__Title",
    componentId: "sc-67ef5f81-1"
})`
	${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'small'
})}
	${FlexMixin()}
  	margin-right: 4px;
	color: ${({ theme  })=>theme.colors.grays.darker};

	& > span {
		padding-left: 8px;
		color: ${({ theme  })=>theme.colors.grays.base};
		${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'small'
})}
	}
`;
export const Info = styled.p.withConfig({
    displayName: "styled__Info",
    componentId: "sc-67ef5f81-2"
})`
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'small'
})}
	margin-top: 4px;
	color: ${({ theme  })=>theme.colors.text.dark};
`;
export const OptionsTitle = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__OptionsTitle",
    componentId: "sc-67ef5f81-3"
})`
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	padding-top: 20px;
`;
export const CounterButtons = styled(Counter).withConfig({
    displayName: "styled__CounterButtons",
    componentId: "sc-67ef5f81-4"
})`
	${CounterButtonMobileWrapper} {
		${BorderRadius({
    all: '2pt'
})}
	}
	label {
		color: ${({ theme  })=>theme.colors.black.base};
	}
`;
export const PersonCounterSelectTitle = styled.p.withConfig({
    displayName: "styled__PersonCounterSelectTitle",
    componentId: "sc-67ef5f81-5"
})`
	margin-top: 12px;
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'small'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
`;
export const IconWrapper = styled.div.withConfig({
    displayName: "styled__IconWrapper",
    componentId: "sc-67ef5f81-6"
})`
	i {
		color: ${({ theme  })=>theme.colors.primary.base};
		font-size: 20px;
		margin-left: 4px;
	}
`;
export const TooltipStyled = styled(Tooltip).withConfig({
    displayName: "styled__TooltipStyled",
    componentId: "sc-67ef5f81-7"
})`
	${TooltipContent} {
		color: ${({ theme  })=>theme.colors.text};
		${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'base'
})}
		padding: 8px 16px;
		text-align: left;
		max-width: 280px;
	}
`;
export const ContentLabel = styled.div.withConfig({
    displayName: "styled__ContentLabel",
    componentId: "sc-67ef5f81-8"
})``;
export const Label = styled.div.withConfig({
    displayName: "styled__Label",
    componentId: "sc-67ef5f81-9"
})`
	${FlexMixin()};
`;

//# sourceMappingURL=styled.js.map